<template>
  <div :class="$style.ctn">
    <Stats :class="$style.stats" :values="stats" />
    <h3 :class="[com.subtitle, $style.title]">
      Modification events
    </h3>
    <PaginationTable
      :class="$style.table"
      :head="eventsHead"
      :values="events"
      :show-head="false"
      :pagination-detach="true"
      :table-wrapper-class="media.eventsTableWrapper"
    >
      <template #row="props">
        <tr
          v-show="props.show"
          :class="[$style.row, $style.rowTop, { [$style.rowFirst]: props.isFirst }]"
        >
          <td><span>(PID) Process:</span></td>
          <td>
            <span>{{ props.row.pid }}</span>
          </td>
          <td><span>Key:</span></td>
          <td>
            <span>{{ props.row.key }}</span>
          </td>
        </tr>
        <tr v-show="props.show" :class="$style.row">
          <td><span>Operation:</span></td>
          <td>
            <span>{{ props.row.operation }}</span>
          </td>
          <td><span>Name:</span></td>
          <td>
            <span>{{ props.row.name }}</span>
          </td>
        </tr>
        <tr
          v-show="props.show"
          :class="[
            $style.row,
            $style.rowBot,
            { [$style.rowLast]: props.isLast, [$style.rowLastPrint]: props.isLastPrint },
          ]"
        >
          <td :colspan="4">
            <div>
              <div :class="$style.spanValue">
                <div>Value:</div>
                <div>{{ props.row.value }}</div>
              </div>
            </div>
          </td>
        </tr>
      </template>
    </PaginationTable>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import PaginationTable from './PaginationTable.vue';
import Stats from './Stats.vue';

export default defineComponent({
  components: { Stats, PaginationTable },
  inject: ['root'],
  data: () => ({
    eventsHead: [{ width: 95 }, { width: 213 }, { width: 37 }, { width: 735 }],
  }),
  computed: {
    events() {
      return this.root.registryActivity.modificationEvents;
    },
    stats() {
      return this.root.registryActivity.stats;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding-top: 20px;
}

.stats {
  & + .title {
    margin-top: 40px;
  }
}

.title {
  & + .table {
    margin-top: 15px;
  }
}

.row {
  &:nth-child(6n + 1),
  &:nth-child(6n + 2),
  &:nth-child(6n + 3) {
    & > td > *::before {
      background: var(--secondary-cell-color);
    }
  }

  & > td {
    & > * {
      font-size: 12px;
      letter-spacing: 0.02em;
      display: block;
      height: 100%;
      overflow-wrap: anywhere;
      word-break: break-word;
      padding-top: 10px;
    }
    &:nth-child(odd) > * {
      font-weight: 500;
      color: #3f4757;
      overflow-wrap: initial;
    }
    &:nth-child(even) > * {
      color: #59606e;
      padding-left: 10px;
      padding-right: 10px;
    }

    &:first-child > * {
      padding-left: 14px;
      &::before {
        border-left: 1px solid var(--table-border-color);
      }
    }

    &:last-child > * {
      padding-right: 14px;
      &::before {
        border-right: 1px solid var(--table-border-color);
      }
    }
  }
}
.spanValue {
  display: flex;
  & > *:nth-child(odd) {
    flex: none;
  }
  & > *:nth-child(even) {
    overflow-wrap: anywhere;
    word-break: break-word;
    color: #59606e;
    padding-left: 10px;
    font-weight: normal;
  }
}

.rowTop {
  & > td > * {
    padding-top: 12px;
    &::before {
      border-top: 1px solid var(--table-border-color);
    }
  }
}

.rowBot {
  & > td {
    & > * {
      padding-bottom: 12px;
    }
  }
}

@media not print {
  .rowLast > td {
    & > *::before {
      border-bottom: 1px solid var(--table-border-color);
    }
    &:last-child > *::before {
      border-bottom-right-radius: 6px;
    }
    &:first-child > *::before {
      border-bottom-left-radius: 6px;
    }
  }
}

@media print {
  .rowLastPrint > td {
    & > *::before {
      border-bottom: 1px solid var(--table-border-color);
    }
    &:last-child > *::before {
      border-bottom-right-radius: 6px;
    }
    &:first-child > *::before {
      border-bottom-left-radius: 6px;
    }
  }
}

.rowFirst {
  & > td {
    &:last-child > *::before {
      border-top-right-radius: 6px;
    }
    &:first-child > *::before {
      border-top-left-radius: 6px;
    }
  }
}
</style>

<style lang="scss" src="./common.module.scss" module="com"></style>
<style lang="scss" src="./media.module.scss" module="media"></style>
